import {push} from 'connected-react-router'
import {useDispatch} from 'react-redux'
import Navigation from '../Navigation'

const LaunchPage = (props) => {
    const dispatch = useDispatch()

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
            <div className="row">
                <div className="col-xs-12">
                    <h1>Collector Licence</h1>
                    <div id="summary">Apply for a Collector Licence. You need the licence if you are employed by collection agency to trace debtors or collect debt in Nova Scotia on behalf of other companies.</div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-8">

                    <p>By law, collection agenecies must have a Collector Licence if you are employed by a collection agency to trace debtors or collect money from debtors in Nova Scotia on behalf of other companies.</p>
                    <p>If you are the manager of a collection agency or a branch location, you need to get a Collector Licence, as well as successfully complete the managers exam (75% is the pass mark). The application to write the exam is part of the Collecot Licence application process.</p>
                    <p>If you aren't a manager, you don't have to write the manager's exam, but you still have to get a Collector Licence.</p>
                    
                    <h2>Eligibility</h2>

                    <p>You need to be 19 or older to apply. Your employer needs to have a Collection Agency Licence.</p>
                    
                    <h3>How to apply</h3>
                    <ol>
                        <li>Complete the online application form</li>
                        <li>You'll be prompted to send your completed application back to your employer.</li>
                        <li>Your employer will submit your application on your behalf.</li>
                        <li>Your licence will be sent to your employer.</li>
                    </ol>
                    
                    <h3>How long it takes</h3>
                    <p>It should take 2 weeks to get the licence (sent to your employer). It can take longer if more information is needed of if your application hasn't been filled correctly.</p>
                    
                    <h3>Cost</h3>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Activity</th>   
                                <th scope="col">Fee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Licence</td>
                                <td>$66.00</td>
                            </tr>
                            <tr>
                                <td>Manager's exam</td>
                                <td>$49.80</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>Payment Options</h3>
                    <p>Visa,MasterCard,Americal Express,cheque, money order. A cheque or money order should be made payable to the Minister of Finance. Payment options may vary depending on how you apply.</p>
                    
                    <h3>Before you start</h3>
                    <p>Make sure you have : </p>
                    <ul style={{listStyleType: " - "}}>
                        <li>Signature of your employer, who needs to be an office (or designate) of a licensed collection agency.</li>
                        <li>business operating name and address of your employer</li>
                        <li>Registry of Joint Stock Companies number of your employer</li>
                        <li>your 3-year employment history</li>
                    </ul>
                    
                    <p>You also need to provide details if you have : </p>
                    <ul style={{listStyleType: ' - '}}>
                        <li>been licensed under any federal or provincial statute.</li>
                        <li>had a licence refused, suspended or revoked</li>
                        <li>been involved in a personal or corporate bankrupcy.</li>
                        <li>unpaid judgements outstanding</li>
                        <li>been convincted or an offence and not been pardoned</li>
                    </ul>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="secondary-content">
                    <h3>Contact</h3>
                        <a href="https://beta.novascotia.ca/contact/service-nova-scotia-and-internal-services#SNS-BLS-01">Business Licensing Section</a>
                    </div>

                    <div className="secondary-content">
                        <h3>Related legislation</h3>
                        <ul>
                            <li><a href="https://nslegislature.ca/sites/default/files/legc/statutes/collection agencies.pdf">Collection Agencies Act(pdf)</a></li>
                            <li><a href="https://novascotia.ca/just/regulations/regs/caregs.htm">Collection Agencies Regulations</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row bottomMarginMedium">
                <div className="col-lg-4">
                    <button 
                        id="apply-online-now"
                        className="btn-lg btn-success"
                        onClick={() => {
                            // start new application
                            dispatch(push('/collector/new/privacy-notice'))
                        }}>
                        Apply online now 
                        &nbsp;
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div className="row bottomMarginMedium">
                <h3>Renewal</h3>
                <p>The collection agency needs to renew your Collector Licence by April 30 each year. They should get a renewal notice in the mail before the renewal date.Renewal of the individual collector is at the discretion of the collection agency.</p>
            </div>
            </div>
        </>
    )
}

export default LaunchPage